import angular from 'angular';

angular.module('myConsultApp').directive('inputSelect', () => {
  return {
    templateUrl: 'templates/v2/input-select.html',
    restrict: 'E',
    scope: {
      id: '@',
      placeholder: '@',
      nextFn: '&',
      searchFn: '&',
      onSelect: '&',
      keyField: '@',
      titleField: '@',
      valueField: '@',
      preselected: '=',
      blankValue: '=',
      filterItems: '=',
    },
    link: ($scope, elem) => {
      $scope.records = [];
      $scope.filteredRecords = [];
      $scope.meta = {};
      $scope.currentData = $scope.placeholder;
      $scope.isVisible = false;
      $scope.scrollList = null;
      $scope.selected = [];
      var first_choice = {};
      if ($scope.placeholder) {
        first_choice[$scope.valueField] = null;
        first_choice.num_points = null;
        first_choice[$scope.titleField] = $scope.placeholder;
      }

      $scope.matchPreselected = async () => {
        if (!$scope.records.length) {
          await $scope.getData();
        }
        $scope.selected = [];
        if (
          $scope.preselected &&
          $scope.preselected != undefined &&
          $scope.preselected[$scope.valueField] != undefined &&
          !angular.equals($scope.preselected[$scope.valueField], $scope.blankValue) &&
          $scope.records.length > 0
        ) {
          var index = 0;
          angular.forEach($scope.records, (option, key) => {
            if (
              $scope.preselected[$scope.valueField] == option[$scope.valueField] ||
              (String($scope.preselected[$scope.valueField]).match(/^[0-9]/) != null &&
                Boolean(option[$scope.valueField]) == $scope.preselected[$scope.valueField])
            ) {
              $scope.selected.push(true);
              $scope.selectOption(option, index);
            } else {
              $scope.selected.push(false);
            }
            index++;
          });
        } else if (
          $scope.preselected &&
          $scope.preselected != undefined &&
          $scope.preselected[$scope.valueField] == undefined &&
          !angular.equals($scope.preselected, $scope.blankValue) &&
          $scope.records.length > 0
        ) {
          var index = 0;
          angular.forEach($scope.records, (option, key) => {
            if (
              $scope.preselected == option[$scope.valueField] ||
              (String($scope.preselected).match(/^[0-9]/) != null &&
                $scope.preselected <= 1 &&
                option[$scope.valueField] <= 1 &&
                Boolean(option[$scope.valueField]) == Boolean($scope.preselected))
            ) {
              $scope.selected.push(true);
              $scope.selectOption(option, index);
            } else {
              $scope.selected.push(false);
            }
            index++;
          });
        } else if (
          $scope.preselected != null &&
          $scope.preselected != undefined &&
          $scope.preselected[$scope.valueField] != undefined &&
          !angular.equals($scope.preselected[$scope.valueField], $scope.blankValue) &&
          ($scope.preselected[$scope.valueField] == 0 ||
            $scope.preselected[$scope.valueField] == false)
        ) {
          var index = 0;
          angular.forEach($scope.records, (option, key) => {
            if (
              Boolean($scope.preselected[$scope.valueField]) == Boolean(option[$scope.valueField])
            ) {
              $scope.selected.push(true);
              $scope.selectOption(option, index);
            } else {
              $scope.selected.push(false);
            }
            index++;
          });
        } else if (
          $scope.preselected != null &&
          $scope.preselected != undefined &&
          $scope.preselected[$scope.valueField] == undefined &&
          ($scope.preselected == 0 || $scope.preselected == false)
        ) {
          var index = 0;
          angular.forEach($scope.records, (option, key) => {
            if (Boolean($scope.preselected) == Boolean(option[$scope.valueField])) {
              $scope.selected.push(true);
              $scope.selectOption(option);
            } else {
              $scope.selected.push(false);
            }
            index++;
          });
        } else {
          angular.forEach($scope.records, (option, key) => {
            $scope.selected.push(false);
          });
          $scope.selected[0] = true;
          $scope.selectOption(first_choice, 0);
        }
        $('.select-options').scrollTop(0);
      };

      $scope.getData = async () => {
        $scope.selected = [];
        if ($scope.searchFn) {
          await $scope.searchFn().then((res) => {
            $scope.$apply(() => {
              $scope.records = res[$scope.keyField];
              if (first_choice[$scope.titleField]) {
                $scope.records.unshift(first_choice);
              }
              $scope.filteredRecords = $scope.filterRecords($scope.records, $scope.filterItems);
              $scope.meta = res.meta;
            });
          });
        }
        $scope.scrollList = $(elem).find('.select-options');
        $scope.scrollMonitor();
        $scope.matchPreselected();
      };

      $scope.showOptions = () => {
        $scope.isVisible = !$scope.isVisible;
      };

      $scope.selectOption = (option, index) => {
        angular.forEach($scope.selected, (option, key) => {
          $scope.selected[key] = false;
        });
        $scope.selected[index] = true;
        $scope.currentData = option[$scope.titleField];
        $scope.onSelect({ option });
      };

      $(document).on('click', (event) => {
        const selectFieldEle = $('.select-field');
        const $target = $(event.target);
        if (
          selectFieldEle !== event.target &&
          !$target.closest('.select-field').length &&
          !selectFieldEle.has(event.target).length
        ) {
          $scope.$apply(() => {
            $scope.isVisible = false;
          });
        }
      });

      $scope.scrollMonitor = () => {
        $scope.scrollList.scroll((event) => {
          const scroll = $scope.scrollList.scrollTop();
          const scrollHeight =
            elem.find('.select-option').outerHeight() * (elem.find('.select-option').length - 10);

          if ($scope.nextFn && $scope.meta && $scope.meta.next && scroll >= scrollHeight) {
            $scope.nextFn({ query: $scope.meta.next }).then((res) => {
              $scope.$apply(() => {
                $scope.records = [...$scope.records, ...res[$scope.keyField]];
                $scope.filteredRecords = $scope.filterRecords($scope.records, $scope.filteritems);
                $scope.meta = res.meta;
                $scope.matchPreselected();
              });
            });
          }
        });
      };

      $scope.$watch('filterItems', () => {
        $scope.filteredRecords = $scope.filterRecords($scope.records, $scope.filterItems);
      });

      $scope.filterRecords = (records, filterItems) => {
        const ids = !filterItems ? [] : filterItems.map((item) => item[$scope.valueField]);

        return !records ? [] : records.filter((item) => !ids.includes(item[$scope.valueField]));
      };

      $scope.$watch('preselected', () => {
        $scope.matchPreselected();
      });

      $scope.getData();
    },
  };
});
